import { render, staticRenderFns } from "./LogoDisplay.vue?vue&type=template&id=6065432a&scoped=true"
import script from "./LogoDisplay.vue?vue&type=script&lang=js"
export * from "./LogoDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065432a",
  null
  
)

export default component.exports